// @flow
/* eslint-disable react/no-danger */
import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import { CAN_USE_DOM } from 'common/constants';
import { Responsive } from '../../Responsive';
import css from './Article.scss';

type Props = {
	text: string,
	objects: any[],
};

export function Article({ text, objects }: Props) {
	const [HTMLString, setHTMLString] = useState(text);
	const HTMLElements = {};
	const replacedElements = [];

	useEffect(() => {
		if (CAN_USE_DOM) {
			if (text.includes('https://twitter.com')) {
				const script = document.createElement('script');
				script.src = 'https://platform.twitter.com/widgets.js';
				if (document.head) {
					document.head.appendChild(script);
				}
			}
			if (text.includes('instagram')) {
				console.info('Instagram');
			}
			_.each(objects, i => createHTMLElements(i));

			replaceMarkupWithRealHTML();
		}
	}, []);

	const createHTMLElements = item => {
		if (item.ID === 0) return;

		switch (item.Type) {
			case 'Image':
				replacedElements.push({ type: item.Type.toLocaleLowerCase(), id: item.ID });
				HTMLElements[item.ID] = `<div class="${css.imageSection}">
						<img src="${item.URL}" alt="" />
						<h6 class="${css.imageCaption}">
							${item.Caption} (${item.Credit})
						</h6>

					</div>`;
				break;
			case 'Video':
				replacedElements.push({ type: item.Type.toLocaleLowerCase(), id: item.ID });
				HTMLElements[item.ID] = renderVideo(item);
				break;

			default:
				break;
		}
	};

	const renderVideo = videoData => {
		const isDesktop = Responsive.isMatching(Responsive.DESKTOP);
		const videoSrc = isDesktop ? videoData.URL_SD : videoData.URL_Mobile;

		let videoType = 'video/mp4';
		if (videoSrc) {
			const videoTypeArr = videoSrc.split('.');
			const type = videoTypeArr[videoTypeArr.length - 1];

			switch (type) {
				case 'mp4':
				case 'm4v':
					videoType = 'video/mp4';
					break;
				case 'm3u8':
					videoType = 'application/x-mpegURL';
					break;
				case 'ogg':
					videoType = 'video/ogg';
					break;
				default:
					videoType = 'application/x-mpegURL';
					break;
			}
		}

		return `<div class="${css.videoSection}"><div class="${
			css.videoWrapper
		}"><video src="${videoSrc}" type="${videoType}" controls ></video></div><h6 class="${css.videoCaption}">${_.get(
			videoData,
			'Caption',
			''
		)}</h6></div>`;
	};

	const replaceMarkupWithRealHTML = () => {
		let newText = text;
		_.each(replacedElements, el => {
			let strForReplacing = '';
			if (el.type === 'image') {
				strForReplacing = `<${el.type} id="${el.id}" />`;
			}
			if (el.type === 'video') {
				strForReplacing = `<${el.type} id="${el.id}" />`;
			}
			const updatedText = newText.replace(strForReplacing, HTMLElements[el.id]);
			newText = updatedText;
		});

		setHTMLString(newText);
	};

	return (
		<div className={css.article}>
			<p dangerouslySetInnerHTML={{ __html: HTMLString }} />
		</div>
	);
}
